import React from 'react';
import styles from './Layout.scss.js';
import { AnnotatedSection } from './components/AnnotatedSection/AnnotatedSection.js';
import { Section } from './components/Section/Section.js';

var Layout = function Layout(_ref) {
  var sectioned = _ref.sectioned,
      children = _ref.children;
  var content = sectioned ?
  /*#__PURE__*/
  React.createElement(Section, null, children) : children;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: styles.Layout
    }, content)
  );
};

Layout.AnnotatedSection = AnnotatedSection;
Layout.Section = Section;
export { Layout };